@if (displayTask && !displayTask.isDirectCall) {
  <div class="task-view" [class.extended-teams-toast]="isExtendingTeamsToast$ | async">
    <div class="task-trigger-content">
      @if (displayTask.isServiceCall && !isDetailsLoaded) {
        <div class="loading-spinner">
          <i [nimbusIcon]="ICONS.SPINNER" [iconWeight]="IconWeight.Regular"></i>
        </div>
      }
      @if (tabItems?.length) {
        <div class="tab-page">
          <nimbus-material-tabs-wrapper>
            @for (tabItem of tabItems; track tabItem.id) {
              <nimbus-material-tab [model]="tabItem" (tabSelect)="navigateTo(tabItem?.id)"> </nimbus-material-tab>
            }
          </nimbus-material-tabs-wrapper>
          <div class="tab-form-body">
            <div class="tab-content" [class.tab-content-flow]="isTabActive('flow')">
              @if (isTabActive('codes')) {
                <app-task-codes-tab [task]="displayTask"></app-task-codes-tab>
              }
              @if (isTabActive('flow')) {
                <app-task-flow-tab [task]="displayTask"></app-task-flow-tab>
              }
              @if (isTabActive('context')) {
                <app-task-context-tab [task]="displayTask"></app-task-context-tab>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
} @else if (displayTask?.isDirectCall) {
  <div class="direct-call-view">
    <img class="duty-img" [src]="onDutyImage" alt="duty" />
  </div>
}
